import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { ColDef } from 'ag-grid-community/dist/lib/entities/colDef';
import { Observable, of } from 'rxjs';

import { GridRowSelect, SummaryButton, SummaryItem } from '../../../models';
import { ModalService } from '../../../services';
import { GridComponent } from '../../grids';
import { BaseInlineFormComponent } from '../../base-inline-form/base-inline-form.component';

@Component({
  selector: 'app-grid-modal',
  templateUrl: './grid-modal.component.html',
  styleUrl: './grid-modal.component.scss',
})
export class GridModalComponent {
  @ViewChild(BaseInlineFormComponent) form: BaseInlineFormComponent;
  @ViewChild(GridComponent, { static: true }) grid: GridComponent;
  @Input() stateKey: string;
  @Input() header = '';
  @Input() columnDefs: ColDef[] = [];
  @Input() summaryTop: any;
  @Input() formModel: any;
  @Input() multiSelectRows = true;
  @Input() rowData$: Observable<any[]> = of([]);
  @Input() rowData: any[];
  @Input() summaryItems: (model: any) => SummaryItem[];
  @Input() showDelete = false;
  @Input() labelsVertical = false;
  @Input() fullWidth = false;
  @Input() fields: FormlyFieldConfig[];
  @Input() inlineHeader = '';
  @Input() gridHeader = '';
  @Input() saveButtonText = $localize`Save`;
  @Input() submitText = '';
  @Input() submitIcon = '';
  @Input() gridCssClass = 'modal-grid';
  @Input() showBack = true;
  @Input() additionalButtons: SummaryButton[];
  @Output() create = new EventEmitter<any>();
  @Output() delete = new EventEmitter<any>();
  @Output() edit = new EventEmitter<any>();
  @Output() comment = new EventEmitter<any>();
  @Output() rowSelected = new EventEmitter<GridRowSelect>();
  @Output() submitted = new EventEmitter<any>();
  @Output() save = new EventEmitter<void>();

  constructor(private modalService: ModalService) {}

  get observableSummaryTopModel() {
    return of(this.summaryTop);
  }

  get showSave(): boolean {
    return this.save.observed;
  }

  get gridStateKey() {
    return `Modal.${this.stateKey ?? this.header}`;
  }
}
